<div class="venue-form-container">
  <form nz-form [formGroup]="form" [nzLayout]="'vertical'">

    <div class="form-section">
      <!-- <div class="section-header">
        <h3 class="section-title">Venue Requirements</h3>
      </div> -->

      <!-- Legacy single venue/room type/seating style selects (superseded by the repeatable
           venue_rooms rows below, which support pairing more than one venue). -->
      <!--
      <nz-form-item>
        <nz-form-label nzRequired>Venue</nz-form-label>
        <nz-form-control nzErrorTip="Please select venue">
          <nz-select nzShowSearch nzAllowClear formControlName="venue" nzPlaceHolder="Select venue">
            <nz-option *ngFor="let v of venueOptionsResponseModel.value.results" [nzValue]="v.id" [nzLabel]="v.name">
            </nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired>Room Type</nz-form-label>
        <nz-form-control nzErrorTip="Please select room type">
          <nz-select nzShowSearch nzAllowClear formControlName="room_type" nzPlaceHolder="Select room type">
            <nz-option *ngFor="let v of filteredRoomTypes" [nzValue]="v.id" [nzLabel]="v.name">
            </nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired>Seating Style</nz-form-label>
        <nz-form-control nzErrorTip="Please select seating style">
          <nz-select nzShowSearch nzAllowClear formControlName="seating_style" nzPlaceHolder="Select seating style">
            <nz-option *ngFor="let v of seatingStylesResponseModel.value.results" [nzValue]="v.id" [nzLabel]="v.name">
            </nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
      -->

      <div formArrayName="venue_rooms">
        <div class="venue-rooms-grid">
          <div class="venue-room-row" *ngFor="let room of venueRoomsArray.controls; let i = index" [formGroupName]="i">
            <div class="venue-room-row-header">
              <span class="venue-room-row-title">Venue {{ i + 1 }}</span>
              <button nz-button nzType="text" nzDanger nzShape="circle" type="button"
                *ngIf="venueRoomsArray.length > 1" (click)="removeVenueRoom(i)" nz-tooltip nzTooltipTitle="Remove">
                <i nz-icon nzType="delete" nzTheme="outline"></i>
              </button>
            </div>

            <nz-form-item>
              <nz-form-label nzRequired>Venue</nz-form-label>
              <nz-form-control nzErrorTip="Please select venue">
                <nz-select nzShowSearch nzAllowClear formControlName="venue" nzPlaceHolder="Select venue">
                  <nz-option *ngFor="let v of venueOptionsResponseModel.value.results" [nzValue]="v.id" [nzLabel]="v.name">
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>

            <nz-form-item>
              <nz-form-label nzRequired>Room Type</nz-form-label>
              <nz-form-control nzErrorTip="Please select room type">
                <nz-select nzShowSearch nzAllowClear formControlName="room_type" nzPlaceHolder="Select room type">
                  <nz-option *ngFor="let v of getFilteredRoomTypes(i)" [nzValue]="v.id" [nzLabel]="v.name">
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>

            <nz-form-item>
              <nz-form-label nzRequired>Seating Style</nz-form-label>
              <nz-form-control nzErrorTip="Please select seating style">
                <nz-select nzShowSearch nzAllowClear formControlName="seating_style" nzPlaceHolder="Select seating style">
                  <nz-option *ngFor="let v of seatingStylesResponseModel.value.results" [nzValue]="v.id" [nzLabel]="v.name">
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>

          <button nz-button nzType="dashed" type="button" class="add-venue-room-tile" (click)="addVenueRoom()">
            <i nz-icon nzType="plus"></i>
            <span>Add another venue</span>
          </button>
        </div>
      </div>

      <nz-form-item>
        <nz-form-label nzRequired>Breakout Rooms Required</nz-form-label>
        <nz-form-control nzErrorTip="Please select if breakout rooms are required">
          <nz-radio-group formControlName="is_breakout_rooms_required">
            <label nz-radio [nzValue]="true">Yes</label>
            <label nz-radio [nzValue]="false">No</label>
          </nz-radio-group>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item *ngIf="form.get('is_breakout_rooms_required')?.value">
        <nz-form-label nzRequired>Number of Breakout Rooms</nz-form-label>
        <nz-form-control nzErrorTip="Please enter number of breakout rooms">
          <input nz-input type="number" formControlName="number_of_breakout_rooms" min="1" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-control>
          <button nz-button nzType="primary" (click)="onSave()" [disabled]="form.invalid">
            Submit
          </button>
        </nz-form-control>
      </nz-form-item>
    </div>

  </form>
</div>